import { useState } from "react";
import { useAuth } from "../lib/AuthContext";
import PricingModal from "./PricingModal";

const COLORS = {
  bg: "#FFFBEB",
  border: "#FDE68A",
  text: "#1A1917",
  textSecondary: "#6B6860",
  accent: "#2B5CE6",
  green: "#1A8754",
};

/**
 * Upgrade banner shown to free-tier recruiters inside the dashboard.
 * Compact inline banner (not a full-page wall).
 * Clicking "Upgrade" opens PricingModal with 3-tier comparison.
 */
export default function UpgradeBanner({ usage }) {
  const { profile } = useAuth();
  const [showPricing, setShowPricing] = useState(false);

  // Don't show for pro/enterprise users, admins, or careers
  if (
    profile?.tier === "pro" ||
    profile?.tier === "enterprise" ||
    profile?.subscription_status === "active" ||
    profile?.role === "admin" ||
    profile?.role === "careers"
  ) {
    return null;
  }

  const searchesUsed = usage?.searches_used ?? 0;
  const searchesLimit = usage?.searches_limit ?? 5;
  const cvRequestsUsed = (usage?.connections_used ?? 0) + (usage?.cv_downloads_used ?? 0);
  const cvRequestsLimit = 5;
  const nearLimit = searchesUsed >= searchesLimit * 0.8 || cvRequestsUsed >= cvRequestsLimit * 0.8;

  return (
    <>
      <div style={{
        backgroundColor: nearLimit ? "#FEF2F2" : COLORS.bg,
        border: `1px solid ${nearLimit ? "#FECACA" : COLORS.border}`,
        borderRadius: 10,
        padding: "16px 20px",
        marginBottom: 20,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 16,
        flexWrap: "wrap",
      }}>
        <div>
          <div style={{
            fontSize: 14,
            fontWeight: 600,
            color: COLORS.text,
            marginBottom: 4,
          }}>
            {nearLimit ? "You're running low on free usage" : "You're on the Free plan"}
          </div>
          <div style={{
            fontSize: 13,
            color: COLORS.textSecondary,
          }}>
            {searchesUsed}/{searchesLimit} searches &middot; {cvRequestsUsed}/{cvRequestsLimit} CV requests
          </div>
        </div>
        <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}>
          <button
            onClick={() => setShowPricing(true)}
            style={{
              padding: "10px 20px",
              borderRadius: 8,
              border: "none",
              backgroundColor: COLORS.accent,
              color: "#fff",
              fontSize: 13,
              fontWeight: 700,
              fontFamily: "inherit",
              cursor: "pointer",
              whiteSpace: "nowrap",
              transition: "all 0.15s",
            }}
          >
            Upgrade to Pro &mdash; &euro;79/year
          </button>
          <button
            onClick={() => setShowPricing(true)}
            style={{
              fontSize: 12,
              color: COLORS.textSecondary,
              textDecoration: "underline",
              whiteSpace: "nowrap",
              background: "none",
              border: "none",
              cursor: "pointer",
              fontFamily: "inherit",
            }}
          >
            Enterprise? Reach out
          </button>
        </div>
      </div>

      {showPricing && (
        <PricingModal
          onClose={() => setShowPricing(false)}
          currentTier={profile?.tier || "free"}
        />
      )}
    </>
  );
}
